import React from 'react';
import ResetPassword from './resetPassword';

class resetPasswordPage extends React.Component {
	render() {
		const { history } = this.props;
		return(
			<div className="min-h-fullscreen center-vh p-20 pace-done">
				<ResetPassword history={history}/>
			</div>
		);
	}
}

export default resetPasswordPage;


